import { render, staticRenderFns } from "./TabBtn.vue?vue&type=template&id=0c1f1696&scoped=true"
import script from "./TabBtn.vue?vue&type=script&lang=js"
export * from "./TabBtn.vue?vue&type=script&lang=js"
import style0 from "./TabBtn.vue?vue&type=style&index=0&id=0c1f1696&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1f1696",
  null
  
)

export default component.exports